import ImageModel from './ImageModel';

export default class SitecoreImageModel {
  constructor() {
    this.value = new ImageModel();

    this.editable = '';
  }
  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'value')) {
      this.value.getData(dataSource.value ?? {});
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'editable')) {
      this.editable = dataSource.editable ?? this.editable;
    }
    
    return this;
  }
}
